import { formatSvDate, formatSvTime, isSameSvDay, STOCKHOLM_TZ, toDate } from "@/utils/date";

const FALLBACK_HOME = "Hemmalag";
const FALLBACK_AWAY = "Bortalag";

function getSnapshot(match = {}) {
  return (
    match?.official_snapshot ||
    match?.officialSnapshot ||
    match?.official_match ||
    match?.officialMatch ||
    {}
  );
}

function extractDateValue(raw) {
  if (!raw) return null;
  if (raw instanceof Date) return raw.toISOString();
  if (typeof raw === "number") return raw;
  if (typeof raw === "string") return raw;
  if (typeof raw === "object") {
    if (raw.$date) return raw.$date;
    if (raw.date) return raw.date;
    if (typeof raw.toISOString === "function") return raw.toISOString();
  }
  return null;
}

function getStartRaw(match = {}) {
  const snapshot = getSnapshot(match);
  return (
    extractDateValue(match?.date) ||
    extractDateValue(match?.start) ||
    extractDateValue(match?.start_time) ||
    extractDateValue(snapshot.start) ||
    extractDateValue(snapshot.date) ||
    extractDateValue(snapshot.start_time) ||
    extractDateValue(snapshot.scheduled_start)
  );
}

export function parseMatchDate(match) {
  if (!match) return null;
  const raw = getStartRaw(match);
  if (!raw) return null;
  const dt = new Date(raw);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

export function toDateKey(date) {
  const dt = toDate(date);
  if (!dt || Number.isNaN(dt.getTime())) return null;
  const parts = new Intl.DateTimeFormat("sv-SE", {
    timeZone: STOCKHOLM_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(dt);
  const get = (type) => parts.find((p) => p.type === type)?.value || "";
  return `${get("year")}-${get("month")}-${get("day")}`;
}

export function describeMatchStart(match) {
  const dt = parseMatchDate(match);
  if (!dt) {
    return {
      dateLabel: "Datum ej klart",
      timeLabel: "",
      isToday: false,
      isPast: false,
      date: null,
    };
  }

  const now = new Date();
  const isToday = isSameSvDay(dt, now);

  return {
    dateLabel: formatSvDate(dt, {
      weekday: "short",
      day: "numeric",
      month: "short",
    }),
    timeLabel: formatSvTime(dt, {
      hour: "2-digit",
      minute: "2-digit",
    }),
    isToday,
    isPast: dt < now,
    date: dt,
  };
}

export function getMatchVenue(match) {
  const snapshot = getSnapshot(match);
  return (
    match?.venue ||
    match?.location ||
    snapshot.venue ||
    snapshot.location ||
    snapshot.arena ||
    ""
  );
}

export function getMatchTeams(match) {
  const snapshot = getSnapshot(match);
  const home =
    match?.home_team ||
    match?.home ||
    snapshot.home_team ||
    snapshot.home ||
    match?.home_team_name ||
    snapshot.home_team_name ||
    FALLBACK_HOME;
  const away =
    match?.away_team ||
    match?.away ||
    snapshot.away_team ||
    snapshot.away ||
    match?.away_team_name ||
    snapshot.away_team_name ||
    FALLBACK_AWAY;

  return { home: home || FALLBACK_HOME, away: away || FALLBACK_AWAY };
}

export function getMatchTitle(match, separator = " vs ") {
  const { home, away } = getMatchTeams(match);
  return `${home}${separator}${away}`;
}
